import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { getOperatorWork } from "../services/ConnectDataBase";
import { SCREEN_IDS } from "../components/FullComponent.js";
import { typeConnect, backgroundColor2 } from "../constants/Constants";
import { formatTime } from "../services/Functions.js";
import { ADMIN_OPERATION_SCREEN_COLORS } from "../style/colors.js";
import { useSelector } from "react-redux";
import { translateText } from "../translations/translationService";

export default function AdminOperationScreen({ navigation }) {
  const currentScreenId = SCREEN_IDS.ADMIN_OPERATION;
  const lang = useSelector((state) => state.lang.value);
  const [listOperator, setListOperator] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    operationLoad();
  }, []);

  const operationLoad = async () => {
    setIsLoading(true);
    try {
      const listaOperarios = await getOperatorWork(
        currentScreenId,
        typeConnect[0]
      );

      if (listaOperarios) {
        setListOperator(listaOperarios);
      } else {
        setListOperator([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigate = (nombre) => {
    if (navigation && typeof navigation.navigate === "function") {
      navigation.navigate("Operator Panel", { operario: nombre });
    } else {
      console.warn("Función de navegación no disponible");
    }
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant='h5' gutterBottom>
        {translateText("Panel de Administración de Operarios", lang)}
      </Typography>
      {isLoading ? (
        <Box sx={{ textAlign: "center", py: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ maxHeight: "75vh" }}>
          <Table stickyHeader size='small'>
            <TableHead>
              <TableRow sx={{ backgroundColor: ADMIN_OPERATION_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: "bold",
                    position: "sticky",
                    top: 0,
                    backgroundColor: ADMIN_OPERATION_SCREEN_COLORS.BACKGROUND_TABLE_HEADER,
                  }}>
                  {translateText("Operario", lang)}
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: "bold",
                    position: "sticky",
                    top: 0,
                    backgroundColor: ADMIN_OPERATION_SCREEN_COLORS.BACKGROUND_TABLE_HEADER,
                  }}>
                  Team
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: "bold",
                    position: "sticky",
                    top: 0,
                    backgroundColor: ADMIN_OPERATION_SCREEN_COLORS.BACKGROUND_TABLE_HEADER,
                  }}>
                  {translateText("Tiempo diario", lang)}
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: "bold",
                    position: "sticky",
                    top: 0,
                    backgroundColor: ADMIN_OPERATION_SCREEN_COLORS.BACKGROUND_TABLE_HEADER,
                  }}>
                  Nº MOs
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: "bold",
                    position: "sticky",
                    top: 0,
                    backgroundColor: ADMIN_OPERATION_SCREEN_COLORS.BACKGROUND_TABLE_HEADER,
                  }}>
                  {translateText("Ir a Panel", lang)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listOperator.map((item, index) => (
                <TableRow key={index}>
                  <TableCell align='center'>{item.nombre}</TableCell>
                  <TableCell align='center'>{item.equipo}</TableCell>
                  <TableCell align='center'>
                    {formatTime(item.tiempo_total)}
                  </TableCell>
                  <TableCell align='center'>{item.cantidad_mos}</TableCell>
                  <TableCell align='center'>
                    <Button
                      variant='contained'
                      onClick={() => handleNavigate(item.nombre)}
                      align='center'
                      sx={{
                        backgroundColor: backgroundColor2,
                        color: "white",
                        "&:hover": {
                          backgroundColor: ADMIN_OPERATION_SCREEN_COLORS.BACKGROUND_DARK,
                        },
                      }}>
                      {translateText("Ir", lang)}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
